/**
 * AbortError helpers for the index client and its providers. Same shape as
 * the palette core's `types.js` (§12.1 rule 4: an `AbortError` is silent),
 * kept here so the index folder has no dependency on core internals.
 */
export function abortError() {
  if (typeof DOMException === 'function') {
    try {
      return new DOMException('Aborted', 'AbortError');
    } catch {
      /* fall through */
    }
  }
  const e = new Error('Aborted');
  e.name = 'AbortError';
  return e;
}

export function isAbortError(err) {
  return !!err && err.name === 'AbortError';
}

/** Normalise like the index does: NFKD, marks stripped, lower-case, ß→ss, đ→dj, æ→ae. */
export function normalizeText(s) {
  return String(s ?? '')
    .replace(/ß/g, 'ss')
    .replace(/[đĐ]/g, 'dj')
    .replace(/[æÆ]/g, 'ae')
    .replace(/[œŒ]/g, 'oe')
    .replace(/[øØ]/g, 'o')
    .replace(/[łŁ]/g, 'l')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
}

/** §12.2.1 tokenizer: quoted phrases stay one term, whitespace splits the rest. */
export function indexTerms(q) {
  const terms = [];
  const re = /"([^"]*)"|(\S+)/g;
  const s = String(q ?? '');
  let m;
  while ((m = re.exec(s)) !== null) {
    const t = normalizeText((m[1] !== undefined ? m[1] : m[2]).trim()).replace(/\s+/g, ' ');
    if (t && !terms.includes(t)) terms.push(t);
  }
  return terms;
}

export const TASK_KEY_RE = /^[A-Za-z][A-Za-z0-9]{1,4}-[1-9][0-9]{0,8}$/;
